/**
 *
 * Popover
 *
 */

import React from 'react';

class Popover extends React.PureComponent {
  state = { isOpen: false };

  componentDidMount() {
    document.addEventListener('mousedown', this.onOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onOutsideClick);
  }

  clickWasOutside = (target) => (
    target === this.refArea
      ? false
      : !!target
      ? this.clickWasOutside(target.parentNode)
      : true
  )

  onOutsideClick = (e) => {
    e.stopPropagation();

    if (this.state.isOpen && this.clickWasOutside(e.target)) {
      this.toggleIsOpen();
    }
  }

  toggleIsOpen = () => this.setState({ isOpen: !this.state.isOpen });

  render() {
    const { isOpen } = this.state;
    const { children, style, actions } = this.props;

    return (
      <div
        onClick={isOpen ? noop => noop : this.toggleIsOpen}
        ref={(ref) => this.refArea = ref}>
        {children[0]}
        <div style={{ zIndex: 1, position: 'relative', ...style }}>
          {isOpen ? (typeof children[1] === 'function' ? children[1](this.toggleIsOpen) : children[1]) : null}
          {actions ? actions(this.toggleIsOpen) : null}
        </div>
      </div>
    );
  }
}

export default Popover;



// WEBPACK FOOTER //
// ./src/components/Popover/index.js